<template>
  <CCol :xl="checkLength()" :lg="checkLength()" :md="checkLength()" :sm="checkLength()">
    <CCard class="cardCustom">
      <CCardBody class="CustomCardBody">
        <CRow
          alignHorizontal="center"
          alignVertical="center"
          @mouseover="hover = true"
          @mouseleave="hover = false"
          @click="linkTo(cardContent)"
        >
          <img
            v-if="hover"
            class="mock-pic"
            :src="baseURL+cardContent.icon.enable.data"
            width="100%"
          />
          <img
            v-else
            class="mock-pic"
            :src="baseURL+cardContent.icon.disable.data"
            width="100%"
          />
        </CRow>
        <CRow alignHorizontal="center" alignVertical="center">
          <h1
            :class="checkLangClass()+' '+'ContentInfo pl-3 pr-3'"
            v-html="checkLanguage(cardContent.title)"
          ></h1>
        </CRow>
        <!-- <CRow alignHorizontal="center" alignVertical="center">
          <CButton
            color="success"
            shape="pill"
            size="lg"
            class="ml-2 mr-2 pl-5 pr-5 pt-3 pb-3"
            @click="linkTo(cardContent)"
          >{{checkLanguage(cardContent.navigate.title)}}</CButton>
        </CRow>-->
      </CCardBody>
    </CCard>
  </CCol>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Vocab",
  data() {
    return {
      hover: false,
      lang: this.$store.getters["language/getLanguage"],
      baseURL: process.env.VUE_APP_URL_SOUND,
    };
  },
  props: {
    FuncRoute: Function,
    cardContent: Object,
    openModal: Function,
    dataLength: Number
  },
  computed: {
    ...mapGetters({
      getLanguage: "language/getLanguage",
    }),
  },
  watch: {
    hover() {},
    getLanguage: function (val) {
      this.lang = val;
    },
  },
  mounted() {
  },
  created() {},
  beforeDestroy() {},
  methods: {
    checkLength(){
      if(this.dataLength === 4){
        return 6
      }else{
        return 4
      }
    },
    checkLangClass() {
      if (this.lang == "CN") {
        return "fontChinese";
      } else if (this.lang == "PIN IN") {
        return "fontPinin";
      } else {
        return "";
      }
    },
    linkTo(path) {
      this.isVisible = false;
      this.FuncRoute(path.navigate.action);
    },
    checkLanguage(val) {
      if (val) {
        for (let i = 0; i <= val.length; i++) {
          if (val[i].key == this.lang) {
            var spiltVal = val[i].value;
            let spl = spiltVal.split("-");
            if (spl[1] === undefined) {
              return spl[0];
            } else {
            }
            return spl[0] + "<br/>" + spl[1];
          }
        }
      } else {
      }
    },
  },
};
</script>

<style>
.cardCustom {
  border-radius: 30px !important;
  background-color: #f2f2f2;
  margin-top: 25%;
  height: 70%;
}

.mock-pic {
  text-align: center;
  width: 100%;
  height: 100%;
  position: relative;
  top: 0rem;
  cursor: pointer;
}
.CustomCardBody {
  position: relative;
  top: -5rem;
}
.ContentInfo {
  text-align: center;
  font-size: 30px;
}
</style>